<template>
    <div class="first-information-form1">
        <slot name="how-register-modal"></slot>
        <div class="edit-info" v-if="getEditionMode">
            <b-button
                :variant="getIsDarkTheme ? 'outline-light' : 'outline-dark'"
                size="sm"
                @click="changeStatusDisabled(false)"
            >
                Editar informações
            </b-button>
        </div>

        <b-form @submit.stop.prevent="onSubmit" novalidate>
            <b-form-group
                label="Prestador de serviço/produto"
                label-for="isProvider"
                class="required"
                v-if="id_organizacao === 1"
            >
                <b-form-radio-group
                    id="isProvider"
                    name="isProvider"
                    v-model="$v.form.isProvider.selected.$model"
                    :options="form.isProvider.options"
                    :state="validateState('isProvider')"
                    :disabled="getIsDisabled"
                ></b-form-radio-group>

                <b-form-invalid-feedback :state="validateState('isProvider')">
                    Campo obrigatório
                </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Natureza da iniciativa" label-for="origin" class="required">
                <b-form-select
                    id="origin"
                    name="origin"
                    v-model="$v.form.origin.selected.$model"
                    :options="form.origin.options"
                    :state="validateState('origin')"
                    :disabled="getIsDisabled"
                ></b-form-select>

                <b-form-invalid-feedback :state="validateState('origin')">
                    Campo obrigatório
                </b-form-invalid-feedback>
            </b-form-group>

            <div>
                <b-form-input
                    name="originOthers"
                    style="margin-bottom: 20px;"
                    v-model="form.originOthers"
                    placeholder="Especifique aqui ..."
                    :disabled="getIsDisabled"
                    v-if="form.origin.selected === 8"
                ></b-form-input>
            </div>

            <b-form-group label="Iniciativa" label-for="initiative" class="required">
                <b-form-select
                    id="initiative"
                    name="initiative"
                    v-model="$v.form.initiative.selected.$model"
                    :options="form.initiative.options"
                    :state="validateState('initiative')"
                    :disabled="getIsDisabled"
                ></b-form-select>

                <b-form-invalid-feedback :state="validateState('initiative')">
                    Campo obrigatório
                </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Formato jurídico" label-for="legalFormat" class="required">
                <b-form-select
                    id="legalFormat"
                    name="legalFormat"
                    v-model="$v.form.legalFormat.selected.$model"
                    :options="form.legalFormat.options"
                    :state="validateState('legalFormat')"
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform && getAuthorizationData && getAuthorizationData['id_formato_juridico'].value)
                    "
                ></b-form-select>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['id_formato_juridico'].value"
                />

                <b-form-invalid-feedback :state="validateState('legalFormat')">
                    Campo obrigatório
                </b-form-invalid-feedback>
            </b-form-group>

            <div>
                <b-form-input
                    name="legalFormatOthers"
                    style="margin-bottom: 20px;"
                    v-model="form.legalFormatOthers"
                    placeholder="Especifique aqui ..."
                    :disabled="getIsDisabled"
                    v-if="
                        form.legalFormat.selected === 7 &&
                            (!isPlatform ||
                                (isPlatform &&
                                    getAuthorizationData &&
                                    getAuthorizationData['id_formato_juridico'].value))
                    "
                ></b-form-input>
            </div>

            <b-form-group
                label="Objetivos do Desenvolvimento Sustentável (ODS) 1,2,3"
                label-for="ods"
                class="required"
            >
                <b-form-checkbox-group
                    id="sustainable-development-objectives"
                    name="ods"
                    v-model="$v.form.ods.selected.$model"
                    :options="form.ods.options"
                    value-field="item"
                    text-field="text"
                    :state="validateState('ods')"
                    :disabled="getIsDisabled"
                    v-if="!isPlatform || (isPlatform && getAuthorizationData && getAuthorizationData['ods'].value)"
                ></b-form-checkbox-group>

                <NoAuthorizationMsgPP v-if="isPlatform && getAuthorizationData && !getAuthorizationData['ods'].value" />

                <b-form-invalid-feedback :state="validateState('ods')">
                    <div v-if="!$v.form.ods.selected.required">Campo obrigatório</div>
                    <div v-if="!$v.form.ods.selected.maxSelected">Possível selecionar no máximo 3</div>
                </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
                label="Áreas de atuação da sua iniciativa"
                label-for="areas"
                class="required"
            >
                <b-form-checkbox-group
                    id="areas"
                    name="areas"
                    v-model="$v.form.areas.selected.$model"
                    :options="form.areas.options"
                    value-field="item"
                    text-field="text"
                    :state="validateState('areas')"
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform && getAuthorizationData && getAuthorizationData['principal_area_atuacao'].value)
                    "
                ></b-form-checkbox-group>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['principal_area_atuacao'].value"
                />

                <b-form-input
                    v-model="form.areas.other"
                    class="areas-other-field"
                    type="text"
                    placeholder="Outra opção"
                    :disabled="getIsDisabled"
                    v-if="form.areas.selected.includes(29)"
                ></b-form-input>

                <b-form-invalid-feedback :state="validateState('areas')">
                    <div v-if="!$v.form.areas.selected.required">Campo obrigatório</div>
                    <div v-if="!$v.form.areas.selected.maxSelected">Possível selecionar no máximo 3</div>
                </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
                label="Estado em que a organização/iniciativa está sediada UF"
                label-for="state"
                class="required"
            >
                <b-form-select
                    id="state"
                    name="state"
                    v-model="$v.form.state.selected.$model"
                    :options="form.state.options"
                    :state="validateState('state')"
                    :disabled="getIsDisabled"
                    @change="getCities(form.state.selected)"
                    v-if="
                        !isPlatform ||
                            (isPlatform && getAuthorizationData && getAuthorizationData['estado_desenvolve_acao'].value)
                    "
                ></b-form-select>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['estado_desenvolve_acao'].value"
                />

                <b-form-invalid-feedback :state="validateState('state')">
                    Campo obrigatório
                </b-form-invalid-feedback>
            </b-form-group>

            <div class="position-relative" :class="{ 'loading-field': loadCities }">
                <b-form-group
                    label="Cidade em que a organização/iniciativa está sediada"
                    label-for="city"
                    class="required"
                >
                    <b-form-select
                        id="city"
                        name="city"
                        v-model="$v.form.city.selected.$model"
                        :options="form.city.options"
                        :state="validateState('city')"
                        :disabled="getIsDisabled || form.state.selected === null"
                        v-if="
                            !isPlatform ||
                                (isPlatform &&
                                    getAuthorizationData &&
                                    getAuthorizationData['cidade_desenvolve_acao'].value)
                        "
                    ></b-form-select>

                    <NoAuthorizationMsgPP
                        v-if="
                            isPlatform && getAuthorizationData && !getAuthorizationData['cidade_desenvolve_acao'].value
                        "
                    />

                    <b-form-invalid-feedback :state="validateState('city')">
                        Campo obrigatório
                    </b-form-invalid-feedback>
                </b-form-group>

                <b-spinner :variant="'info'" v-if="loadCities"></b-spinner>
            </div>

            <hr class="line" />

            <div class="footer-buttons">
                <b-button
                    :variant="'secondary'"
                    class="radius-6"
                    @click="$router.push({ name: 'Register' })"
                    v-if="!editionMode && !showFooterButtons"
                >
                    Cancelar
                </b-button>

                <b-button type="submit" :variant="'primary'" class="radius-6 submit" v-if="!showFooterButtons">
                    Próximo
                </b-button>

                <b-button
                    :variant="'primary'"
                    :disabled="!getIsDisabled"
                    @click="changeRegisterForm('FirstInformationForm2')"
                    v-else
                >
                    Próximo
                </b-button>

                <b-button variant="success" @click="saveData(progress)" v-if="getEditionMode && !getIsDisabled">
                    Salvar
                </b-button>
            </div>
        </b-form>

        <DangerModalPP ref="warningModal" :message="message" />
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import axios from 'axios'
import { required } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import { RegisterFirstInformationApi } from '../../api/register-first-information/'
import { AuthorizationApi } from '../../api/admin/authorization-api'
import DangerModalPP from '@/ui/modal/danger-modal-pp/DangerModalPP'
import NoAuthorizationMsgPP from '@/ui/no-authorization-msg-pp/NoAuthorizationMsgPP'

const registerFirstInformationApi = new RegisterFirstInformationApi()
const authorizationApi = new AuthorizationApi()

export default {
    components: { DangerModalPP, NoAuthorizationMsgPP },
    name: 'FirstInformationForm1',
    mixins: [validationMixin],
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        editionMode: {
            type: Boolean,
            default: false
        },
        isPlatform: {
            type: Boolean,
            default: false
        },
        showFooterButtons: {
            type: Boolean,
            default: false
        },
        receiveData: {
            default: null
        },
        userIdLogged: {
            default: null
        },
        allowAuthorization: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            progress: 2.77,
            message: null,
            firstInfoData: null,
            isDisabled: null,
            id_organizacao: null,
            loadCities: false,
            authorizationData: null,
            form: {
                isProvider: {
                    selected: null,
                    options: [
                        { text: 'Sim', value: 1 },
                        { text: 'Não', value: 0 }
                    ]
                },
                origin: {
                    selected: null,
                    options: [{ value: null, text: 'Selecione' }]
                },
                originOthers: null,
                initiative: {
                    selected: null,
                    options: [{ value: null, text: 'Selecione' }]
                },
                legalFormat: {
                    selected: null,
                    options: [{ value: null, text: 'Selecione' }]
                },
                legalFormatOthers: null,
                ods: {
                    selected: [],
                    options: [
                        { text: 'Erradicação da Pobreza', item: 1, value: 1 },
                        { text: 'Redução das Desigualdades', item: 10, value: 10 },
                        { text: 'Fome Zero e Agricultura Sustentável', item: 2, value: 2 },
                        { text: 'Cidades e Comunidades Sustentáveis', item: 11, value: 11 },
                        { text: 'Saúde e Bem-Estar', item: 3, value: 3 },
                        { text: 'Consumo e Produção Responsáveis', item: 12, value: 12 },
                        { text: 'Educação de Qualidade', item: 4, value: 4 },
                        { text: 'Ação Contra a Mudança Global do Clima', item: 13, value: 13 },
                        { text: 'Igualdade de Gênero', item: 5, value: 5 },
                        { text: 'Vida na Água', item: 14, value: 14 },
                        { text: 'Água Potável e Saneamento', item: 6, value: 6 },
                        { text: 'Vida Terrestre', item: 15, value: 15 },
                        { text: 'Energia Limpa e Acessível', item: 7, value: 7 },
                        { text: 'Paz, Justiça e Instituições Eficazes', item: 16, value: 16 },
                        { text: 'Trabalho Decente e Crescimento Econômico', item: 8, value: 8 },
                        { text: 'Parcerias e Meios de Implementação', item: 17, value: 17 },
                        { text: 'Indústria, Inovação e Infraestrutura', item: 9, value: 9 }
                    ]
                },
                areas: {
                    other: null,
                    selected: [],
                    options: [
                        { text: 'Ações Afirmativas: raça, gênero e protagonismo jovem', item: 1, value: 1 },
                        { text: 'Esporte & Saúde', item: 2, value: 2 },
                        { text: 'Advocacy & Incidência Política', item: 3, value: 3 },
                        { text: 'Habitação', item: 4, value: 4 },
                        { text: 'Arte & Cultura', item: 5, value: 5 },
                        { text: 'Inclusão Digital', item: 6, value: 6 },
                        { text: 'Assistência Social', item: 7, value: 7 },
                        { text: 'Bem Viver & Qualidade de Vida', item: 9, value: 9 },
                        { text: 'Comunicação & Marketing', item: 10, value: 10 },
                        { text: 'Justiça Racial', item: 11, value: 11 },
                        { text: 'Defesa de direitos da população LGBTQIAP+', item: 12, value: 12 },
                        { text: 'Meio ambiente / Sustentabilidade', item: 13, value: 13 },
                        { text: 'Defesa de direitos da população negra', item: 14, value: 14 },
                        { text: 'Mobilidade Urbana', item: 15, value: 15 },
                        { text: 'Defesa de direitos das mulheres', item: 16, value: 16 },
                        { text: 'Paz & Justiça', item: 17, value: 17 },
                        { text: 'Defesa de direitos dos povos indígenas', item: 18, value: 18 },
                        { text: 'PCD (Pessoas com Deficiência)', item: 19, value: 19 },
                        { text: 'Desenvolvimento Comunitário', item: 20, value: 20 },
                        { text: 'Pesquisa / Produção de Conhecimento', item: 21, value: 21 },
                        { text: 'Direito dos Animais', item: 22, value: 22 },
                        { text: 'Refugiados', item: 23, value: 23 },
                        { text: 'Direitos humanos, justiça social e cidadania', item: 24, value: 24 },
                        { text: 'Saúde', item: 25, value: 25 },
                        { text: 'Economia criativa e solidária', item: 26, value: 26 },
                        { text: 'Tecnologias Sociais', item: 27, value: 27 },
                        { text: 'Educação', item: 28, value: 28 },
                        {
                            text:
                                'Inclusão Produtiva (empreendedorismo, empregabilidade e capacitação para o mercado de trabalho, geração de trabalho e renda)',
                            item: 8,
                            value: 8
                        },
                        { text: 'Outro (especifique)', item: 29, value: 29 }
                    ]
                },
                state: {
                    selected: null,
                    options: [{ value: null, text: 'Selecione' }]
                },
                city: {
                    selected: null,
                    options: [{ value: null, text: 'Selecione' }]
                }
            }
        }
    },
    validations: {
        form: {
            isProvider: {
                selected: {
                    required() {
                        return !(this.form.isProvider.selected === null && this.id_organizacao === 1)
                    }
                }
            },
            origin: {
                selected: { required }
            },
            initiative: {
                selected: { required }
            },
            legalFormat: {
                selected: { required }
            },
            ods: {
                selected: {
                    required,
                    maxSelected() {
                        return this.form.ods.selected.length <= 3
                    }
                }
            },
            areas: {
                selected: {
                    required,
                    maxSelected() {
                        return this.form.areas.selected.length <= 3
                    }
                }
            },
            state: {
                selected: { required }
            },
            city: {
                selected: { required }
            }
        }
    },
    methods: {
        ...mapActions(['setIsLoading', 'changeProfileId', 'setCurrentFormPlatform', 'setProgress']),
        fetchRead() {
            const data = this.receiveData
            this.form.isProvider.selected = data.prestador_servico
            this.form.origin.selected = data.id_natureza_inicitiva
            this.form.originOthers = data.natureza_iniciativa_outros
            this.form.legalFormatOthers = data.formato_juridico_outros
            this.form.initiative.selected = data.id_iniciativa
            this.form.legalFormat.selected = data.id_formato_juridico
            this.form.ods.selected = data.ods
            this.form.areas.selected = data.principal_area_atuacao
            this.form.state.selected = data.estado_desenvolve_acao
            this.form.city.selected = data.cidade_desenvolve_acao
            this.id_organizacao = data.id_organizacao

            if (this.allowAuthorization) {
                this.setIsLoading(true)

                authorizationApi
                    .getFirstInformations(this.userIdLogged)
                    .then(response => {
                        this.authorizationData = response.data.data
                    })
                    .catch(error => {
                        this.message = error.response.data.message
                        this.$refs.warningModal.showModal()
                    })
                    .finally(() => {
                        this.setIsLoading(false)
                    })
            }
        },
        fetch() {
            if (Object.keys(localStorage).includes('firstInfo')) {
                this.firstInfoData = JSON.parse(localStorage.getItem('firstInfo'))

                this.form.isProvider.selected = this.firstInfoData.prestador_servico
                this.form.origin.selected = this.firstInfoData.id_natureza_inicitiva
                this.form.originOthers = this.firstInfoData.natureza_iniciativa_outros
                this.form.legalFormatOthers = this.firstInfoData.formato_juridico_outros
                this.form.initiative.selected = this.firstInfoData.id_iniciativa
                this.form.legalFormat.selected = this.firstInfoData.id_formato_juridico
                this.form.ods.selected = this.firstInfoData.ods
                this.form.areas.selected = this.firstInfoData.principal_area_atuacao
                this.form.state.selected = this.firstInfoData.estado_desenvolve_acao
                this.form.city.selected = this.firstInfoData.cidade_desenvolve_acao
                this.id_organizacao = this.firstInfoData.id_organizacao

                this.setProgress(this.firstInfoData.percentual)

                this.changeProfileId({
                    idOrganizacao: this.firstInfoData.id_organizacao,
                    prestadorServico: this.firstInfoData.prestador_servico
                })
            } else {
                if (Object.keys(localStorage).includes('usuario')) {
                    this.setIsLoading(true)
                    registerFirstInformationApi
                        .listFirst()
                        .then(res => {
                            this.form.id = res.data.id
                            this.form.possui_cnpj = res.data.possui_cnpj
                            this.form.nome_organizacao = res.data.nome_organizacao
                            this.form.descricao_organizacao = res.data.descricao_organizacao
                            this.form.isProvider.selected = res.data.prestador_servico
                            this.form.origin.selected = res.data.id_natureza_inicitiva
                            this.form.originOthers = res.data.natureza_iniciativa_outros
                            this.form.legalFormatOthers = res.data.formato_juridico_outros
                            this.form.initiative.selected = res.data.id_iniciativa
                            this.form.legalFormat.selected = res.data.id_formato_juridico
                            this.form.ods.selected = res.data.ods
                            this.form.areas.selected = res.data.principal_area_atuacao
                            this.form.state.selected = res.data.estado_desenvolve_acao
                            this.form.city.selected = res.data.cidade_desenvolve_acao
                            this.id_organizacao = res.data.id_organizacao

                            this.setProgress(res.data.percentual)

                            this.getCities(this.form.state.selected)
                            this.changeProfileId({
                                idOrganizacao: res.data.id_organizacao,
                                prestadorServico: res.data.prestador_servico
                            })
                        })
                        .catch(error => {
                            this.message = error.response.data.message
                            this.$refs.warningModal.showModal()
                        })
                        .finally(() => {
                            this.setIsLoading(false)
                        })
                }
            }
        },
        validateState(nameField) {
            const { $dirty, $error } = this.$v.form[nameField]
            return $dirty ? !$error : null
        },
        saveTempData(newProgress) {
            if (this.firstInfoData !== null) {
                this.firstInfoData = {
                    ...this.firstInfoData,
                    id_natureza_inicitiva: this.form.origin.selected,
                    natureza_iniciativa_outros: this.form.originOthers,
                    formato_juridico_outros: this.form.legalFormatOthers,
                    id_iniciativa: this.form.initiative.selected,
                    id_formato_juridico: this.form.legalFormat.selected,
                    ods: this.form.ods.selected,
                    percentual: this.getProgress < newProgress ? newProgress : this.getProgress,
                    principal_area_atuacao: this.form.areas.selected,
                    estado_desenvolve_acao: this.form.state.selected,
                    cidade_desenvolve_acao: this.form.city.selected,
                    prestador_servico: this.form.isProvider.selected
                }

                this.changeProfileId({
                    idOrganizacao: this.id_organizacao,
                    prestadorServico: this.form.isProvider.selected
                })
                localStorage.setItem('firstInfo', JSON.stringify(this.firstInfoData))
                this.setProgress(this.firstInfoData.percentual)
                this.$router.push({ name: 'FirstInformationForm2' })
            }
        },
        saveData(newProgress) {
            this.setIsLoading(true)

            const data = {
                id: this.form.id,
                prestador_servico: this.form.isProvider.selected,
                id_natureza_inicitiva: this.form.origin.selected,
                natureza_iniciativa_outros: this.form.originOthers,
                formato_juridico_outros: this.form.legalFormatOthers,
                id_iniciativa: this.form.initiative.selected,
                id_formato_juridico: this.form.legalFormat.selected,
                ods: this.form.ods.selected,
                percentual: this.getProgress < newProgress ? newProgress : this.getProgress,
                principal_area_atuacao: this.form.areas.selected,
                estado_desenvolve_acao: this.form.state.selected,
                cidade_desenvolve_acao: this.form.city.selected,
                id_organizacao: this.id_organizacao,
                possui_cnpj: this.form.possui_cnpj,
                nome_organizacao: this.form.nome_organizacao,
                descricao_organizacao: this.form.descricao_organizacao
            }

            registerFirstInformationApi
                .updateFirst(data)
                .then(res => {
                    this.setProgress(data.percentual)
                    if (this.getEditionMode) {
                        this.changeStatusDisabled(true)
                    } else {
                        this.$router.push({ name: 'FirstInformationForm2' })
                    }
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => {
                    this.setIsLoading(false)
                })
        },
        onSubmit() {
            this.$v.form.$touch()
            if (this.$v.form.$anyError) {
                return
            }

            if (Object.keys(localStorage).includes('usuario')) {
                this.saveData(this.progress)
            } else {
                // save in localStorage
                this.saveTempData(this.progress)
            }
        },
        changeStatusDisabled(status) {
            this.isDisabled = status
        },
        getUfSelected() {
            return this.form.state.options.filter(item => item.value === this.form.state.selected)[0].uf
        },
        getCities(stateId) {
            this.loadCities = true
            const uf = this.form.state.options.filter(item => item.value === stateId)[0].uf

            registerFirstInformationApi.getCities(uf).then(res => {
                const cities = [{ value: null, text: 'Selecione' }].concat(
                    res.data.map(item => ({ value: item.id, text: item.cidade }))
                )

                this.form.city.options = cities
                this.loadCities = false
            })
        },
        changeRegisterForm(formName) {
            this.setCurrentFormPlatform(formName)
            this.scrollBehavior()
        },
        scrollBehavior(to, from, savedPosition) {
            const ele = document.getElementById('top-register-painel')
            return window.scrollTo({
                top: ele.offsetTop,
                behavior: 'smooth'
            })
        },
        filterData() {
            if (this.receiveData) {
                this.form.ods.options = this.form.ods.options.filter(x => this.form.ods.selected.includes(x.value))
                this.form.areas.options = this.form.areas.options.filter(x => this.form.areas.selected.includes(x.value))
            }
        }
    },
    computed: {
        availableOptions() {
            return this.form.origin.options.filter(opt => this.form.origin.selected.indexOf(opt) === -1)
        },
        getEditionMode() {
            return this.editionMode
        },
        getIsDisabled() {
            return this.isDisabled
        },
        getProfileId() {
            return this.$store.state.profileId
        },
        getIsDarkTheme() {
            return this.$store.state.darkTheme
        },
        getProgress() {
            return this.$store.state.progress
        },
        getAuthorizationData() {
            return this.authorizationData
        }
    },
    created() {
        this.receiveData === null ? this.fetch() : this.fetchRead()
        this.isDisabled = this.disabled
        this.setIsLoading(true)

        axios
            .all([
                registerFirstInformationApi.getInitiativeNature(),
                registerFirstInformationApi.getLegalFormat(),
                registerFirstInformationApi.getInitiativeType(),
                registerFirstInformationApi.getStates()
            ])
            .then(res => {
                const newOriginOptions = this.form.origin.options.concat(
                    res[0].data.map(item => ({ value: item.id, text: item.natureza }))
                )
                const newLegalFormatOptions = this.form.legalFormat.options.concat(
                    res[1].data.map(item => ({ value: item.id, text: item.formato }))
                )
                const newInitiativeOptions = this.form.initiative.options.concat(
                    res[2].data.map(item => ({ value: item.id, text: item.iniciativa }))
                )
                const listStates = this.form.state.options.concat(
                    res[3].data
                        .map(item => ({ value: item.id, text: item.estado, uf: item.uf }))
                        .sort((a, b) => {
                            return a.text > b.text ? 1 : b.text > a.text ? -1 : 0
                        })
                )

                this.form.origin.options = newOriginOptions
                this.form.legalFormat.options = newLegalFormatOptions
                this.form.initiative.options = newInitiativeOptions
                this.form.state.options = listStates

                this.getCities(this.form.state.selected)
            })
            .finally(() => {
                this.filterData()
                this.setIsLoading(false)
            })
    }
}
</script>

<style scope src="./FirstInformationForm1-light-theme.css"></style>



// WEBPACK FOOTER //
// src/components/register-first-information-forms/FirstInformationForm1.vue